import React, { Suspense } from "react";
import { Outlet } from "react-router-dom";
import NewHeader from "./NewHeader";
import Loading from "../Loading";

const NewFooter = React.lazy(() => import("./NewFooter"));
const MainLayout = () => {
  return (
    <>
      {/* <NewHeader /> */}
      <Outlet />
      {/* <Suspense fallback={<Loading />}>
        <NewFooter />
      </Suspense> */}
    </>
  );
};

export default MainLayout;
